import { useLanguage } from '../../Providers/LanguageProvider/LanguageProvider.js';

const useTranslation = () => {
    const { language, translations } = useLanguage();
    const translate = (key) => {
        const keys = key.split('.');
        let result = translations[language];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // let returnString: any;
        if (!result) {
            //FIXME:  Handle the case where translations[language] is undefined
            return '';
        }
        for (const k of keys) {
            if (result && typeof result[k] === 'string') {
                result = result[k];
            }
            else if (result && result[k]) {
                result = result[k];
            }
            else {
                return ''; // return a default message if a key does not exist in result
            }
        }
        if (typeof result === 'string') {
            return result;
        }
        else {
            return ''; // return a default message if result is not a string
        }
    };
    return translate;
};

export { useTranslation as default };
//# sourceMappingURL=useTranslation.js.map
